export default __webpack_public_path__ + "static/media/news (3).9281b1e1.webp";